import React, { useState, useEffect, useRef } from 'react';
import styles from './ParentsSection.module.css';

const ParentsSection: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

 useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    },
    {
      threshold: 0.2,
      rootMargin: '0px'
    }
  );

  const currentRef = sectionRef.current;

  if (currentRef) {
    observer.observe(currentRef);
  }

  return () => {
    if (currentRef) {
      observer.unobserve(currentRef);
    }
  };
}, []);

  return (
    <section className={styles.parentsSection} ref={sectionRef}>
      <div className="container">
        <div className={`${styles.parentsFrame} ${isVisible ? styles.fadeInUp : ''}`}>
          <h3 className={`${styles.blessingText} ${isVisible ? styles.slideIn : ''}`}>
            Con la bendición de Dios<br />
            y en compañía de mis<br />
            padres y padrinos
          </h3>
          
          <div className={styles.parentsInfo}>
            <div className={`${styles.parentGroup} ${isVisible ? styles.slideIn : ''}`}>
              <h4>Mis Padres</h4>
              <p>Juan Carlos García Rivera</p>
              <p>Ana Elizabeth Silva Juárez</p>
            </div>
            
            <div className={`${styles.parentGroup} ${isVisible ? styles.slideIn : ''}`}>
              <h4>Mis Padrinos</h4>
              <p>J Remedios Badillo Vargas</p>
              <p>Ma. Concepción Garcia Rivera</p>
            </div>
          </div>
          
          <p className={`${styles.invitationText} ${isVisible ? styles.slideIn : ''}`}>
            Nos complace invitarte a ser<br />
            parte de este gran día.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ParentsSection;